import './css/style.css'
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Home from './pages/hp';
import Gallery from './pages/gallery';
import Tattoo from './pages/tattoo';
import Piercing from './pages/piercing';
import Microdermal from './pages/microdermal';
import Ostudiu from './pages/ostudiu';
import Podminkyobjednani from './pages/podminkyobjednani';
import Kontakt from './pages/kontakt';
import Login from './pages/login';
import Error from './pages/error';
import SharedLayout from './pages/SharedLayout';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<SharedLayout/>}>
                    <Route index element={<Home/>}/>
                    <Route path="/tattoo" element={<Tattoo/>}/>
                    <Route path="/piercing" element={<Piercing/>}/>
                    <Route path="/microdermal" element={<Microdermal/>}/>
                    <Route path="/o-studiu" element={<Ostudiu/>}/>
                    <Route path="/galerie" element={<Gallery/>}/>
                    <Route path="/podminky-objednani" element={<Podminkyobjednani/>}/>
                    <Route path="/kontakt" element={<Kontakt/>}/>
                    <Route path="*" element={<Error/>}/>
                </Route>
                <Route path="/login" element={<Login/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
